export const AR = {
  //Authentication
  login: "تسجيل الدخول",
  dont_have_any_account: "ليس لديك حساب؟",
  do_you_have_any_account: "هل لديك حساب؟",
  privacy_policy_text: "بالنقر على زر المتابعة أو المتابعة من خلال طرف ثالث، فإنك توافق على جميع شروط Upload The Truth",
  privacy_policy: "سياسة الخصوصية",
  and_others: "وغيرهم.",
  register_now: "سجّل الآن",
  forgot_password: "هل نسيت كلمة المرور؟",
  is_it_your_account: "هل هذا حسابك؟",
  contact_with: "تواصل مع",
  support_team: "فريق الدعم",
  send_otp: "إرسال رمز التحقق",
  an_otp_will_be_sent_to_your_phone: "سيتم إرسال رمز تحقق إلى هاتفك / بريدك الإلكتروني",
  email_or_phone: "الهاتف / البريد الإلكتروني",
  enter_email_or_phone: "يرجى إدخال رقم الهاتف أو البريد الإلكتروني.",
  send: "إرسال",
  write_appropriate_note: "اكتب ملاحظة مناسبة هنا",
  select_date: "حدد التاريخ",
  last_activity_date: "تاريخ آخر نشاط (اختياري)",
  recent_password: "كلمة المرور الأخيرة (اختياري)",
  fb_username: "اسم مستخدم فيسبوك",
  phone: "الهاتف",
  email_placeholder: "أدخل عنوان البريد الإلكتروني",
  contact_email: "بريد الاتصال",
  google_account: "حساب جوجل",
  account_created_with: "تم إنشاء الحساب باستخدام",
  continue_with: "متابعة باستخدام",
  google: "جوجل",
  facebook: "فيسبوك",
  whatsapp: "واتساب",
  registration: "التسجيل",
  register: "تسجيل",
  full_name: "الاسم الكامل",
  profile_picture: "صورة الملف الشخصي",
  failed: "فشل!",
  success: "نجاح",
  an_6_digit_code: "رمز مكون من ٦ أرقام",
  was_sent: "تم إرساله",
  didnt_receive_code: "لم تستلم الرمز؟",
  resend: "إعادة الإرسال",
  verify: "تحقق",
  verify_your_email: "تحقق من بريدك الإلكتروني",
  verify_your_mobile: "تحقق من رقم هاتفك",
  please_try_again_after: "يرجى المحاولة مرة أخرى بعد",
  otp_will_be_expired_in: "سينتهي صلاحية رمز التحقق في",
  is_change: "تغيير؟",
  go_back: "العودة",
  invalid_otp_code: "رمز التحقق غير صحيح!",
  confirm_your_mobile: "قم بتأكيد رقم هاتفك",
  choose_how_you_want_to_confirm: "اختر كيفية تأكيد أن",
  belongs_to_you: "ينتمي إليك.",
  send_code_via_sms: "'إرسال الرمز عبر 'رسالة نصية",
  send_code_via_whatsapp: "إرسال الرمز عبر واتساب",
  old_password: "كلمة المرور القديمة",
  new_password: "كلمة المرور الجديدة",
  confirm_password: "تأكيد كلمة المرور",

  // Empty
  no_data: "لا توجد بيانات",
  there_is_no_data: "لا توجد بيانات",
  no_data_available: "لا تتوفر بيانات",
  there_are_no_records_to_display: "لا توجد سجلات للعرض",

  //COMMON_TEXT
  welcome: "مرحبًا",
  welcome_back: "مرحبًا بعودتك",
  login_your_account: "قم بتسجيل الدخول إلى حسابك",
  notification: "إشعار",
  hello: "مرحبًا!",
  happy_to_see_you_again: "سعيد لرؤيتك مرة أخرى",
  overview: "نظرة عامة",
  most_recent: "الأحدث",
  view_all: "عرض الكل",
  change_status: "تغيير الحالة",
  camera: "الكاميرا",
  gallery: "المعرض",
  image: "صورة",
  language: "اللغة",
  session_timeout: "انتهاء الجلسة",
  file: "ملف",
  go: "انتقل",
  select_language: "اختر اللغة",
  enter: "أدخل",

  // Labels
  title: "العنوان",
  new: "جديد",
  description: "الوصف",
  details: "التفاصيل",
  optional: "اختياري",
  start_date: "تاريخ البدء",
  expire_start_date: "تاريخ بدء الانتهاء",
  expire_end_date: "تاريخ انتهاء الصلاحية",
  end_date: "تاريخ الانتهاء",
  active: "نشط",
  none: "لا أحد",
  n_a: "غير متاح",
  deactivate: "إلغاء التنشيط",
  write_here: "اكتب هنا",
  select: "اختر",
  search_option: "خيار البحث",
  first_name: "الاسم الأول",
  last_name: "الاسم الأخير",
  username: "اسم المستخدم",
  email: "البريد الإلكتروني",
  mobile: "الهاتف المحمول",
  new_password: "كلمة المرور الجديدة",
  confirm_new_password: "تأكيد كلمة المرور الجديدة",
  select_one: "اختر واحدًا",
  action: "الإجراء",
  status: "الحالة",
  type: "النوع",
  total: "الإجمالي",
  birth_date: "تاريخ الميلاد",
  gender: "الجنس",
  phone_number: "رقم الهاتف",
  postal_code: "الرمز البريدي",
  address: "العنوان",
  name: "الاسم",
  document: "المستند",
  note: "ملاحظة",
  password: "كلمة المرور",
  date: "التاريخ",
  city: "المدينة",
  cap: "الحد الأعلى",
  not_define: "غير محدد",
  logo: "الشعار",
  advance: "متقدم",
  otp: "رمز التحقق",
  tags: "الوسوم",
  report: "تقرير",
  anonymous: "مجهول",
  see_more: "...عرض المزيد",
  optimizing: "جارٍ التحسين...",
  you_r_searching_for: "أنت تبحث عن...",

  // Alert
  oops: "عذرًا",
  are_you_sure: "هل أنت متأكد؟",
  are_you_sure_to_logout: "هل أنت متأكد من تسجيل الخروج؟",
  you_wont_be_able_to_revert_this: "لن تتمكن من التراجع عن هذا!",
  are_you_sure_you_want_to_delete: "هل أنت متأكد أنك تريد الحذف؟",
  this_action_will_permanently_delete_the_item_and_cannot_be_undone: "هذا الإجراء سيؤدي إلى حذف العنصر نهائيًا ولا يمكن التراجع عنه.",
  yes_delete_it: "نعم، احذفه!",
  yes_confirm_it: "نعم، تأكيد!",
  page_not_found: "عذرًا! الصفحة غير موجودة",
  back_to_login: "العودة إلى تسجيل الدخول",

  login_success: "تم تسجيل الدخول بنجاح",
  login_failed: "فشل تسجيل الدخول",
  invalid_username_or_password: "اسم المستخدم أو كلمة المرور غير صحيحة",

  successfully: "بنجاح",
  successfully_done: "تم بنجاح",
  submitted: "تم الإنشاء بنجاح",
  created_successfully: "تم الإرسال!",
  updated_successfully: "تم التحديث بنجاح",
  deleted_successfully: "تم الحذف بنجاح",
  status_changed_successfully: "تم تغيير الحالة بنجاح",

  permission_denied: "تم رفض الإذن",
  permission_denied_message: "مطلوب إذن التخزين لتنزيل الملف.",
  please_check_your_permission_and_try_again: "ما لم تمنحنا الإذن، لا يمكننا العمل",
  file_saved_to: "تم حفظ الملف في",
  duplicate_not_allowed: "غير مسموح بالتكرار",
  you_missed_some_required_fields: "لقد فاتتك بعض الحقول المطلوبة",
  please_check_all_required_fields: "يرجى التحقق من جميع الحقول المطلوبة",
  no_internet_connection: "لا يوجد اتصال بالإنترنت",
  please_check_your_internet_connection_and_try_again: "يرجى التحقق من اتصالك بالإنترنت والمحاولة مرة أخرى.",
  something_went_wrong_try_again: "حدث خطأ ما، حاول مرة أخرى",
  something_went_wrong: "حدث خطأ ما",
  we_are_working_on_it: "نحن نعمل على ذلك. رحلتك للحصول على المكافأة لا تزال مستمرة!",
  please_try_again_later: "يرجى المحاولة لاحقًا.",
  please_try_again: "يرجى المحاولة مرة أخرى.",
  your_item_has_been_deleted: "تم حذف العنصر الخاص بك",
  please_enter_empty_field: "يرجى إدخال الحقل الفارغ!",

  update_location: "تحديث موقعك",
  update_location_description: "نحن نجمع موقع بلد المستخدم لعرض محتوى أفضل.",
  thank_you: "شكرًا لك!",

  // SUCCESS_MESSAGES
  forgot_password_support: "لقد أرسلنا بريدًا إلكترونيًا إلى العنوان الذي قدمته يحتوي على تعليمات لإعادة تعيين كلمة المرور الخاصة بك.",
  user_contact: "سوف نتواصل معك عبر البريد الإلكتروني قريبًا.",
  registration_success: "تم التسجيل بنجاح! مرحبًا بك في Upload The Truth.",
  password_change: "تم تحديث كلمة المرور الخاصة بك بنجاح. يمكنك الآن تسجيل الدخول باستخدام كلمة المرور الجديدة.",
  comment_added: "تمت إضافة التعليق بنجاح!",
  report_submitted: "شكرًا لك! تم إرسال تقريرك.",
  post_saved_success: "تم حفظ المنشور بنجاح في قائمة المشاهدة لاحقًا.",
  post_removed_success: "تمت إزالة المنشور بنجاح من قائمة المشاهدة لاحقًا.",
  post_remove_to_watch: "تمت إزالة المنشور بنجاح من قائمة المشاهدة لاحقًا.",
  post_remove_from_history: "تمت إزالة المنشور بنجاح من سجل المشاهدة الخاص بك.",

  // ERROR_MESSAGES
  common_error: "تعذر علينا إكمال طلبك. يرجى التحقق من اتصالك والمحاولة مرة أخرى.",
  validation_error: "خطأ في التحقق من البيانات. يرجى مراجعة مدخلاتك والمحاولة مرة أخرى.",
  registration_error: "واجهنا مشكلة أثناء التسجيل. يرجى المحاولة مرة أخرى لاحقًا.",
  registered_but_not_success: "شكرًا لتسجيلك! يتم التحقق من بياناتك لأسباب أمنية. يرجى المحاولة مرة أخرى بعد بضع دقائق.",
  login_validation: "بيانات اعتماد غير صحيحة. يرجى التحقق من بياناتك والمحاولة مرة أخرى.",
  forgot_password_invalid_username: "يرجى إدخال عنوان بريد إلكتروني صالح أو رقم هاتف مع رمز البلد الصحيح.",
  otp_invalid_phone_whatsapp: "رقم الهاتف الذي أدخلته غير صالح. يرجى المحاولة مرة أخرى.",
  otp_already_sent: "تم إرسال رمز التحقق بالفعل. يرجى المحاولة مرة أخرى بعد انتهاء صلاحية الرمز الحالي.",
  video_compress: "نواجه مشكلات فنية. يرجى المحاولة مرة أخرى لاحقًا.",
  invalid_old_password: "كلمة المرور القديمة التي أدخلتها غير صحيحة. يرجى المحاولة مرة أخرى.", 
  expired_otp: "انتهت صلاحية رمز التحقق. يرجى طلب رمز جديد والمحاولة مرة أخرى.",
  invalid_otp: "يرجى التحقق من الرمز والمحاولة مرة أخرى.",
  otp_required: "يرجى إدخال رمز التحقق للمتابعة.",
  video_thumbnail_problem: "حدثت مشكلة أثناء إنشاء الصورة المصغرة. يرجى المحاولة مرة أخرى.",
  video_file_not_found: "تعذر العثور على ملف الفيديو. يرجى إعادة تحميله.", 
  video_upload: "حدثت مشكلة في تحميل الفيديو الخاص بك. قد يكون تالفًا أو هناك مشكلة في الشبكة. يرجى المحاولة مرة أخرى.",
  notification_error: "لا توجد إشعارات جديدة في الوقت الحالي. ابقَ على اطلاع وشارك في تحميل الحقيقة!",
  search_error: "لا توجد نتائج مطابقة لبحثك. حاول تعديل الكلمات الرئيسية أو استكشاف مواضيع أخرى للعثور على ما تبحث عنه!",
  home_page_error: "تعذر علينا تحميل المحتوى في الوقت الحالي. يرجى التحقق من الاتصال بالإنترنت، تحديث الصفحة، أو المحاولة لاحقًا!",
  profile_view: "تعذر علينا تحميل تفاصيل ملفك الشخصي. يرجى التحقق من اتصالك والمحاولة مرة أخرى.",
  profile_update: "حدث خطأ أثناء حفظ التعديلات. يرجى التأكد من صحة جميع الحقول والمحاولة مرة أخرى.",
  post_manage_data: "تعذر علينا تحميل مقاطع الفيديو الخاصة بك. يرجى التحقق من اتصالك والمحاولة مرة أخرى.",
  post_update: "تعذر حفظ التغييرات في الفيديو الخاص بك. يرجى التحقق من اتصالك والمحاولة مرة أخرى.",
  google_reg: "تعذر علينا استرداد معلوماتك من جوجل. يرجى التأكد من اتصالك والمحاولة مرة أخرى.",
  facebook_reg: "تعذر علينا استرداد معلوماتك من فيسبوك. يرجى التأكد من اتصالك والمحاولة مرة أخرى.",
  storage_low: "مساحة التخزين في جهازك منخفضة. لم تكتمل هذه العملية بشكل صحيح. يرجى تفريغ بعض المساحة والمحاولة مرة أخرى.",

  // form validation
  required: "هذا الحقل مطلوب.",
  min_characters: "يجب أن يحتوي الإدخال على الأقل {min} أحرف.",
  max_characters: "يجب ألا يتجاوز الإدخال {max} أحرف.",
  //
  name_required: "يرجى إدخال الاسم.",
  name_250_characters: "يجب ألا يزيد الاسم عن ٢٥٠ حرفًا.",
  //
  full_name_required: "يرجى إدخال اسمك الكامل.",
  //
  phone_required: "يرجى إدخال رقم الهاتف.",
  phone_15_characters: "يجب ألا يزيد رقم الهاتف عن 15 رقمًا.",
  phone_invalid: "يرجى إدخال رقم هاتف صالح.",
  //
  email_required: "يرجى إدخال البريد الإلكتروني.",
  contact_email_required: "يرجى إدخال بريد إلكتروني للتواصل.",
  email_250_characters: "يجب ألا يزيد البريد الإلكتروني عن ٢٥٠ حرفًا.",
  email_invalid: "يرجى إدخال بريد إلكتروني صالح.",
  //
  address_required: "يرجى إدخال العنوان.",
  address_500_characters: "يجب ألا يزيد العنوان عن ٥٠٠ حرف.",
  //
  old_password_required: "يرجى إدخال كلمة المرور القديمة.",
  //
  password_required: "يرجى إدخال كلمة المرور.",
  password_6_characters: "يجب أن تحتوي كلمة المرور على ٦ أحرف على الأقل.",
  //
  confirm_password_required: "يرجى إعادة إدخال كلمة المرور.",
  password_not_match: "كلمات المرور غير متطابقة.",
  //
  facebook_required: "يرجى إدخال اسم مستخدم فيسبوك.",
  please_select_item: "يرجى تحديد عنصر.",

  // Button
  done: "تم",
  back: "رجوع",
  add: "إضافة",
  add_new: "إضافة جديد",
  next: "التالي",
  save_and_next: "حفظ ومتابعة",
  edit: "تعديل",
  share: "مشاركة",
  update: "تحديث",
  submit: "إرسال",
  create: "إنشاء",
  remove: "إزالة",
  delete: "حذف",
  print: "طباعة",
  cancel: "إلغاء",
  download: "تحميل",
  search: "بحث",
  clear: "مسح",
  yes: "نعم",
  no: "لا",
  upload: "رفع",
  upload_file: "رفع ملف",
  all: "الكل",
  see_more: "عرض المزيد",
  or: "أو",
  ok: "موافق",
  to: "إلى",
  close: "إغلاق",
  logout: "تسجيل الخروج",
  profile: "الملف الشخصي",
  preview: "معاينة",
  confirm: "تأكيد",
  continue: "متابعة",
  skip: "تخطي",
  change: "تغيير",

  // Upload Form
  scanning: "جارٍ المسح...",
  searching_keywords: "البحث عن الكلمات المفتاحية",
  write_a_keyword_here: "اكتب كلمة مفتاحية هنا",
  content_language: "لغة المحتوى",
  description_write: "صف ما يحدث",
  please_write_a_title: "يرجى كتابة عنوان",
  please_write_a_text: "يرجى كتابة نص",
  type_your_text_here: "اكتب نصك هنا...",
  sub_category: "الفئة الفرعية",
  sub_categories: "الفئات الفرعية",
  you_can_choose_maximum_3: "(يمكنك اختيار ما يصل إلى ٣)",
  please_select_a_category: "يرجى اختيار فئة",
  select_category: "اختر فئة",
  category: "فئة",
  categories: "فئات",
  post_anonymously: "النشر بدون هوية",
  hide_your_identity: "إخفاء هويتك",
  create_post: "إنشاء منشور",
  upload_audio: "رفع صوت",
  upload_video: "رفع فيديو",
  display_picture_required: "الصورة المطلوبة للعرض",
  content_location: "موقع المحتوى",
  you_can_add_multiple_keywords: "يمكنك إضافة كلمات مفتاحية متعددة",
  you_can_choose_multiple_languages: "يمكنك اختيار لغات متعددة",
  maximum_3: "الحد الأقصى ٣",

  // Months
  Jan: "يناير",
  Feb: "فبراير",
  Mar: "مارس",
  Apr: "أبريل",
  May: "مايو",
  Jun: "يونيو",
  Jul: "يوليو",
  Aug: "أغسطس",
  Sep: "سبتمبر",
  Oct: "أكتوبر",
  Nov: "نوفمبر",
  Dec: "ديسمبر",

  // Time
  minute: "دقيقة",
  minutes: "دقائق",
  hour: "ساعة",
  hours: "ساعات",
  day: "يوم",
  days: "أيام",
  week: "أسبوع",
  weeks: "أسابيع",
  month: "شهر",
  months: "أشهر",
  year: "سنة",
  years: "سنوات",
  ago: "منذ",
  today: "اليوم",
  yesterday: "أمس",
  days_ago: "منذ أيام",

  // Comments
  comment: "تعليق",
  comments: "تعليقات",
  community_guidelines: "إرشادات المجتمع",
  add_comment_here: "أضف تعليقًا هنا",
  add_your_comment: "أضف تعليقك",
  keep_comment_respectful: "تذكر أن تبقي تعليقك محترمًا واتباع",

  // Sidebar
  trending: "رائج",
  confession: "اعتراف",
  audio: "صوت",
  audios: "أصوات",
  record_audio: "تسجيل صوت",
  add_details: "إضافة تفاصيل",
  edit_details: "تعديل التفاصيل",
  post_details: "تفاصيل المنشور",
  coins_history: "سجل العملات",
  help_feedback: "مساعدة وتعليقات",
  basic_info: "معلومات أساسية",
  already_registered: "مُسجل بالفعل",
  change_password: "تغيير كلمة المرور",
  reset_password: "إعادة تعيين كلمة المرور",
  forgot_password: "نسيت كلمة المرور؟",
  audio_file: "ملف صوتي",
  video: "فيديو",
  videos: "فيديوهات",
  image: "صورة",
  images: "صور",
  power_play: "تشغيل القوة",
  text: "نص",
  texts: "نصوص",
  play: "تشغيل",
  utt_coins: "عملات UTT",
  your_reactions: "ردود أفعالك",
  your_comments: "تعليقاتك",
  my_uploads: "رفعي",
  my_supporting: "دعمي",
  invite_friends: "دعوة الأصدقاء",
  help_center: "مركز المساعدة / الأسئلة الشائعة",
  guidelines_rules: "الإرشادات والقواعد",
  terms_privacy: "شروط الاستخدام . الخصوصية",

  // Version
  version: "الإصدار",
  new_version_available: "إصدار جديد متاح!",
  please_update: "يرجى التحديث الآن.",
  update_now: "التحديث الآن",
  later: "لاحقًا",

  // Bottom Tabs
  home: "الرئيسية",
  pp: "PP",
  save: "حفظ",
  history: "التاريخ",
  upload_your_content: "رفع محتواك",
  save_to_watch_later: "حفظ للمشاهدة لاحقًا",
  remove_from_saved: "إزالة من المحفوظ",
  remove_from_history: "إزالة من التاريخ",

  // General
  app: "التطبيق",
  truth: "الحقيقة",
  fake: "زائف",
  view: "عرض",
  views: "آراء",
  hide: "إخفاء",
  upload_in_progress: "جارٍ رفع الملف...",
  upload_successful: "تم رفع الملف بنجاح",
  profile_info: "معلومات الملف الشخصي",
  manage_activity: "إدارة نشاطك",
  display_channel_name: "اسم القناة / العرض الخاص بك",
  max_50_words: "أقصى ٥٠ كلمة",
  bio_about_yourself: "السيرة الذاتية / عن نفسك",
  max_100_words: "أقصى ١٠٠ كلمة",
  support: "دعم",
  supporter: "داعم",
  supporters: "الداعمون",
  supporting: "الدعم",
  supportings: "الدعوم",
  total_supporters: "إجمالي الداعمين",
  total_supportings: "إجمالي الدعم",
  personal_info: "معلومات شخصية",
  home_country: "البلد الأم",
  home_location: "الموقع المنزلي",
  current: "الحالي",
  delivery: "التوصيل",
  same_as_home_address: "نفس عنوان المنزل",
  same_as_current_address: "نفس العنوان الحالي",
  other_address: "عنوان آخر",
  delivery_address_note: "إذا فزت في أي مسابقة على Upload the Truth، سيتم إرسال الجائزة إلى هذا العنوان.",
  select_country: "اختر البلد",
  current_country: "البلد الحالي",
  current_location: "الموقع الحالي",
  location: "الموقع",
  country: "البلد",
  please_select_a_country: "يرجى اختيار البلد",
  please_select_home_country_first: "يرجى اختيار البلد الأم أولاً",
  please_select_current_country_first: "يرجى اختيار البلد الحالي أولاً",
  please_select_delivery_country_first: "يرجى اختيار بلد التوصيل أولاً",
  we_collect_user_country_location: "نقوم بجمع موقع البلد الخاص بالمستخدم لعرض محتوى أفضل.",
  update_your_location: "تحديث موقعك",
  please_select_language: "يرجى اختيار لغتك",
  privacy_and_security: "الخصوصية والأمان",
  type_otp: "أدخل OTP المكون من ٦ أرقام",
  terms_and_conditions: "الشروط والأحكام",

  setting_and_others: "الإعدادات والأخرى",
  app_language: "لغة التطبيق",
  languages: "اللغات",
  deactivate_account: "تعطيل / حذف الحساب",
  contact_us: "اتصل بنا",
  please_write_number: "يرجى كتابة رقم",
  please_write_email: "يرجى كتابة البريد الإلكتروني",
  please_enter_a_contact_email: "يرجى إدخال بريد إلكتروني للتواصل",
  please_write_valid_email: "يرجى كتابة بريد إلكتروني صالح",
  please_write_subject: "يرجى كتابة الموضوع",
  please_write_message: "يرجى كتابة رسالة",
  thank_you: "شكراً لك!",
  message: "رسالة",
  write_appropriate_message_here: "اكتب رسالة مناسبة هنا",
  subject: "الموضوع",
  reason: "السبب",
  select_reason: "اختيار السبب",
  please_select_reason: "يرجى اختيار السبب",
  write_the_reason: "اكتب السبب",
  please_write_the_reason: "يرجى كتابة السبب",
  delete_request: "إرسال طلب الحذف",
  deactivate_message: `سيتطلب الأمر ٤٥ يومًا على الأقل لحذف حسابك بالكامل. ولكن إذا قمت بتسجيل الدخول مرة أخرى خلال هذه الفترة، سيتم إلغاء طلب الحذف. في الوقت نفسه،
  لن يتمكن أي شخص من العثور عليك في هذا التطبيق باستثناء بيانات الذاكرة المؤقتة.`,
  support_message: "سنتواصل معك عبر البريد الإلكتروني الذي قمت بتقديمه قريبًا لإرشادك خلال عملية إعادة تعيين كلمة المرور",

  why_upload_the_truth: "لماذا تحميل الحقيقة؟",
  more_videos: "مزيد من الفيديوهات",
  no_internet: "لا يوجد اتصال بالإنترنت",
  confirmation: "تأكيد",
  video_cancel_confirmation_message: "سيتم التخلص من الفيديو المسجل / المحدد من تطبيقك.\nهل ترغب في فعل ذلك؟",
  trimmingText: "معالجة الفيديو الخاص بك",
  video_selection_error: "آه لا! الفيديو الذي اخترته غير موجود أو فشل في التحميل، نأسف لذلك",
  restart: "إعادة تشغيل",

  // Coins
  total_coins: "إجمالي العملات",
  history: "التاريخ",
  coins_history: "سجل العملات",
  coins: "عملات",
  referral_and_gift: "الإحالات والهدايا",
  monetization: "التحقيق المالي",
  you_are_not_yet_eligible_for_monetization: "أنت غير مؤهل بعد لتحقيق الدخل.",
  seven_days_challenges: "تحديات 7 أيام",
  how_to_earn_more_utt_coins: "كيفية كسب المزيد من عملات UTT؟",
  what_is_uut_coins: "ما هي عملات UUT؟",
  how_to_earn_utt_coins: "كيفية كسب عملات UTT؟",
  how_to_use_utt_coins: "كيفية استخدام عملات UTT؟",
  complete: "مكتمل",
  give_10_comment: "أعطِ ١٠ تعليقات",
  upload_3_video_in_crime_category: "رفع ٣ فيديوهات في فئة الجريمة",
  upload_3_pp: "رفع ٣ PP (تشغيل القوة)",
  upload_3_audio: "رفع ٣ أصوات",

  refer_friend_earn: "أحِل صديقًا واربح",
  copy_your_code: "انسخ رمزك، وشاركه مع أصدقائك.",
  your_refer_code: "رمز الإحالة الخاص بك",
  type_your_friends_refer_code: "اكتب رمز الإحالة لصديقك",
  redeem: "استبدال",
  copy: "نسخ",
  enter_code: "أدخل الرمز",
  or_share: "أو شارك",
  how_it_work: "كيف يعمل؟",
  invite_your_friend_by_using_this_code: "ادعُ صديقك باستخدام هذا الرمز",
  they_use_this_code: "يستخدمون هذا الرمز.",
  you_get_500_utt_coins: "تحصل على ٥٠٠ عملة UTT!",
  contact_number: "رقم التواصل",
  shirt_size: "مقاس القميص",
  district: "المنطقة",
  thana: "ثانا",
  delivery_address: "عنوان التوصيل",
  full_address: "العنوان الكامل",
  prize_info_submitted_successfully: "تم إرسال معلومات الجائزة بنجاح."
}